import React, { Component } from 'react';
import { Modal, Row, Col, Table} from 'react-bootstrap';
import _ from 'lodash';

export default class ViewUser extends Component {
      
     render(){
      let clientobj=[], processObj=[], centerObj=[], regionObj=[];
      const{data} = this.props;
      _.map(data.userInventoryMaps, (x) =>{
        regionObj.push(x.inventoryRegionName)
        _.map(x.userCenters, (y) =>{
          centerObj.push(y.inventoryCenterName)
        _.map(y.userClients, (z) =>{
          clientobj.push(z.inventoryClientName)
          clientobj = _.uniqBy(clientobj);
         _.map(z.userProcesses, (z1) =>{              
          processObj.push({"process":z1.inventoryProcessName, "category":z1.inventoryCategoryName});  
          processObj = _.uniqBy(processObj, "process");          
          })
         })
        })
      })     
      return(
      <Modal show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w"
      size='xl'
      aria-labelledby="contained-modal-title-vcenter"
      centered>  
       <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">View User Details</Modal.Title>   
      </Modal.Header>
      <Modal.Body>
      <div>
        <Row className="marginBottom">
          <Col md={3}><b>USER ID</b><br/><span className='colorBlue'>{data.employeeId}</span></Col>
          <Col md={3}><b>FIRST NAME</b><br/><span className='colorBlue'>{data.firstName}</span></Col>
          <Col md={3}><b>LAST NAME</b><br/><span className='colorBlue'>{data.lastName}</span></Col>
          <Col md={3}><b>EMAIL</b><br/><span className='colorBlue'>{data.email}</span></Col>
        </Row>
        <Row className="marginBottom">          
          <Col md={3}><b>MOBILE NUMBER</b><br/><span className='colorBlue'>{data.mobileNumber}</span></Col>
          <Col md={3}><b>SUPERVISOR</b><br/><span className='colorBlue'>{!_.isEmpty(data.supervisorUsersName) ? data.supervisorUsersName + "," +data.supervisorUsersId
          : "No Supervisor Mapped"  
        }</span></Col>
          <Col md={3}><b>ROLE</b><br/><span className='colorBlue'>{data.rolesName}</span></Col>          
          <Col md={3}><b>REGION NAME</b><br/><span className='colorBlue'>{_.map(regionObj, (x, index) =>{
           return (<span className="wordspan">{(index ? ', ' : '') + x}</span>)  })}</span></Col>
        </Row>
        <Row>          
          <Col md={3}><b>CENTER NAME</b><br/><span className='colorBlue'>{_.map(centerObj, (x, index) =>{
           return (<span className="wordspan">{(index ? ', ' : '') +x}</span>)  })}</span></Col>
           <Col md={3}><b>CLIENT NAME</b><br/><span className='colorBlue'>{_.map(clientobj, (x, index) =>{
           return (<span className="wordspan">{(index ? ', ' : '') +x}</span>)  })}</span></Col>  
           <Col md={3}></Col>
           <Col md={3}></Col>
        </Row>
        {(!_.isEmpty(processObj) && data.rolesName === 'Agent') ?
        <Row>
          <Col>          
            <Table responsive>
            <thead><th>PROCESS NAME</th><th>AGENT CATEGORY</th>
           </thead>
                <tbody>
                  { _.map(processObj, (obj, i) =>{
                    return(
                      <tr>           
                        <td>{obj.process}</td>
                        <td>{obj.category}</td>
                      </tr>) }) 
                    }                                   
                </tbody>
              </Table>   
              </Col>                       
        </Row> : <Row><Col><b>PROCESS NAME</b><br/><span className='colorBlue'>{_.map(processObj, (x, index) =>{
           return (<span className="wordspan">{(index ? ', ' : '') + x.process
           }</span>)  })}</span></Col></Row>   }
        {!_.isEmpty(data.userLeaveDetails) ?
        <Row className="marginBottom">  
          <Col>
          <b>LEAVE RECORDS</b>
          <Table responsive>
            <thead><th>TO</th><th>FROM</th><th>REASON</th>
            <th>COMMENTS</th><th>NO OF DAYS</th><th>STATUS</th></thead>
                <tbody>
                  { _.map(data.userLeaveDetails, (obj, i) =>{
                    return(
                      <tr>           
                        <td>{obj.toDate}</td>
                        <td>{obj.fromDate}</td>
                        <td>{obj.reasons}</td>
                        <td>{obj.comments}</td>
                        <td>{obj.noOfDays}</td>            
                        <td>{obj.status}</td>
                      </tr>) }) }                                   
                </tbody>
              </Table>
              </Col>
        </Row>
         : null}
        <Row className="marginBottom">                      
          <Col><b>REPORTS</b><br/><span className='colorBlue'>{_.map(data.reports, (x, index) =>{
          return(<span>{(index ? ', ' : '') + x.reportName} &nbsp;</span>)})}</span></Col>
        </Row>
     
        
      </div>
      </Modal.Body>      
      </Modal>
      )
    }
    
 
}

  